import { observer } from 'mobx-react-lite';
import { format, parseISO } from 'date-fns';
import { Modal } from '@/components/ui/Modal';
import { Button } from '@/components/ui/button';
import { AsyncState } from '@/components/ui/AsyncState';
import type { HistoryModal as HistoryModalCtrl } from '@/controllers/clients/clientCard/useHistoryModal';

type Props = { ctrl: HistoryModalCtrl };

export const HistoryModal = observer(function HistoryModal({ ctrl }: Props) {
  return (
    <Modal
      isOpen={ctrl.isOpen}
      onClose={ctrl.close}
      title='История изменений'
      subtitle={ctrl.cameraName}
      size='xl'
      footer={
        <Button variant='outline' onClick={ctrl.close} className='w-full'>
          Закрыть
        </Button>
      }
    >
      <AsyncState
        isLoading={ctrl.isLoading}
        error={ctrl.error}
        isEmpty={ctrl.history.length === 0}
        emptyMessage='История изменений пуста'
      >
        <div className='border border-border/30 rounded-xl overflow-hidden'>
          <div className='grid grid-cols-12 gap-2 px-4 py-2.5 text-xs font-medium text-muted-foreground uppercase tracking-wider bg-muted/20 border-b border-border/20'>
            <div className='col-span-2 text-center'>Дата</div>
            <div className='col-span-1 text-center'>Польз.</div>
            <div className='col-span-2 text-center'>Действие</div>
            <div className='col-span-3 text-center'>Поле</div>
            <div className='col-span-2 text-center'>Было</div>
            <div className='col-span-2 text-center'>Стало</div>
          </div>
          <div className='divide-y divide-border/20'>
            {ctrl.history.map((item, i) => (
              <div
                key={i}
                className='grid grid-cols-12 gap-2 px-4 py-3 items-center hover:bg-muted/20 transition-colors'
              >
                <div className='col-span-2 font-mono text-xs text-muted-foreground text-center'>
                  {item.date ? format(parseISO(item.date), 'dd.MM.yyyy') : '—'}
                </div>
                <div
                  className='col-span-1 text-xs text-muted-foreground truncate text-center'
                  title={item.user}
                >
                  {item.user || '—'}
                </div>
                <div
                  className='col-span-2 text-xs text-foreground truncate text-center'
                  title={item.action}
                >
                  {item.action || '—'}
                </div>
                <div
                  className='col-span-3 text-xs text-muted-foreground truncate text-center'
                  title={item.field_name}
                >
                  {item.field_name || '—'}
                </div>
                <div
                  className='col-span-2 text-xs text-red-400/80 truncate text-center'
                  title={item.old_value ?? undefined}
                >
                  {item.old_value || '—'}
                </div>
                <div
                  className='col-span-2 text-xs text-green-400/80 truncate text-center'
                  title={item.new_value ?? undefined}
                >
                  {item.new_value || '—'}
                </div>
              </div>
            ))}
          </div>
        </div>
      </AsyncState>
    </Modal>
  );
});
